<template>
<div class="summary" :style="{background: $$FormData.theme_color || '#202020'}"><span>{{ $$FormData.title || '我的消费积分' }} <strong>0</strong></span><span v-if="$$FormData.show_details !== false">积分明细 ›</span></div>
</template>
<script>
export default { name: 'PointsSummaryPreview' }
</script>
<style scoped>
.summary { padding: 22px 12px; color: #fff; display: flex; justify-content: space-between; font-size: 12px; }
.summary strong { margin-left: 12px; font-size: 22px; }
.goods,.coupons { background: #fff; padding: 12px; font-size: 12px; }
h3 { margin: 0 0 14px; font-size: 16px; }
p,small { color: #999; } small { font-size: 10px; }
.card,.coupon { display: flex; gap: 12px; align-items: center; padding: 16px 0; border-bottom: 1px solid #eee; }
.card i { font-size: 36px; color: #b69d70; }
.card span,.coupon span { margin-left: auto; padding: 5px 8px; border-radius: 4px; background: #202020; color: #fff; }
.coupon strong { font-size: 26px; color: #b69d70; }
.row-two { display: flex; gap: 8px; }.row-two .card { width: 50%; flex-direction: column; align-items: flex-start; }
</style>
